module.exports = __webpack_public_path__ + "img/partecipanti_smartform.9aed98bd.png";